import { Permission } from '../../core/auth/permissions';
import { ERole } from '../../core/auth/roles';
import { environment } from '../../../environments/environment';

// TLL renames the learner nav (epic "[EO] Home Experience"): Dashboard -> Home, Course Catalog -> Course
// Library. SK12 keeps its labels. Brand-conditional here so the rename never touches the SK12 nav.
const isTll = environment.brand === 'tll';
const HOME_LABEL = isTll ? 'Home' : 'Dashboard';
const COURSE_LIBRARY_LABEL = isTll ? 'Course Library' : 'Course Catalog';

export interface MenuItem {
  label: string;
  icon: string;
  route: string;
  anyPerm?: Permission[];
  guestOnly?: boolean;
  onlyRoles?: ERole[];
  /** Roles that must NOT see this item, even if they hold the permission (deny-list, applied after anyPerm). */
  excludeRoles?: ERole[];
  order?: number;
  orderByRole?: Partial<Record<ERole, number>>;
  labelByRole?: Partial<Record<ERole, string>>;
}

export const MENU: MenuItem[] = [
  {
    label: COURSE_LIBRARY_LABEL,
    icon: 'course-catalog',
    route: '/course-catalog',
    guestOnly: true,
  },

  {
    label: COURSE_LIBRARY_LABEL,
    icon: 'course-catalog',
    route: '/course-catalog',
    orderByRole: {
      [ERole.SuperAdmin]: 50,
      [ERole.SupportAdmin]: 30,
      [ERole.GroupAdmin]: 30,
      [ERole.SubGroupAdmin]: 30,
      [ERole.Learner]: 30,
    },
  },

  {
    label: HOME_LABEL,
    icon: 'dashboard',
    route: '/dashboard',
    anyPerm: [Permission.AccessLearnerArea],
    onlyRoles: [ERole.Learner],
    orderByRole: { [ERole.Learner]: 10 },
  },
  {
    label: 'My Achievements',
    icon: 'achievements',
    route: '/my-achievements',
    anyPerm: [Permission.AccessLearnerArea],
    onlyRoles: [ERole.Learner],
    orderByRole: { [ERole.Learner]: 20 },
  },

  {
    label: 'User Management',
    icon: 'user-management',
    route: '/user-management',
    anyPerm: [Permission.ViewUserManagement],
    orderByRole: {
      [ERole.SuperAdmin]: 10,
      [ERole.SupportAdmin]: 10,
      [ERole.GroupAdmin]: 10,
      [ERole.SubGroupAdmin]: 10,
    },
  },
  {
    label: 'Groups',
    labelByRole: { [ERole.GroupAdmin]: 'My Group', [ERole.SubGroupAdmin]: 'My Group' },
    icon: 'groups',
    route: '/groups',
    anyPerm: [Permission.ViewGroups],
    orderByRole: {
      [ERole.SuperAdmin]: 20,
      [ERole.SupportAdmin]: 20,
      [ERole.GroupAdmin]: 20,
      [ERole.SubGroupAdmin]: 20,
    },
  },
  {
    label: 'Products',
    icon: 'products',
    route: '/product-management',
    anyPerm: [Permission.ManageProducts],
    orderByRole: { [ERole.SuperAdmin]: 30 },
  },
  {
    label: 'Memberships',
    icon: 'membership',
    route: '/memberships',
    anyPerm: [Permission.ManageMemberships],
    orderByRole: { [ERole.SuperAdmin]: 40 },
  },
  {
    label: 'Course Categories',
    icon: 'categories',
    route: '/category-management',
    anyPerm: [Permission.ManageCategories],
    orderByRole: { [ERole.SuperAdmin]: 60 },
    // TLL (PM decision): hide this tab from Super/Support admins. SK12 keeps it unchanged.
    excludeRoles: isTll ? [ERole.SuperAdmin, ERole.SupportAdmin] : undefined,
  },

  {
    label: 'Profile',
    icon: 'profile',
    route: '/profile',
    orderByRole: {
      [ERole.SuperAdmin]: 100,
      [ERole.SupportAdmin]: 100,
      [ERole.GroupAdmin]: 100,
      [ERole.SubGroupAdmin]: 100,
      [ERole.Learner]: 100,
    },
  },
  {
    label: 'Reports',
    icon: 'reports',
    route: '/reports',
    anyPerm: [Permission.Reports],
    orderByRole: {
      [ERole.SuperAdmin]: 120,
      [ERole.SupportAdmin]: 120,
      [ERole.GroupAdmin]: 120,
      [ERole.SubGroupAdmin]: 120,
    },
  },
];
